import { Dispatch, SetStateAction, useEffect } from 'react';

import { RowSelectionState } from '@tanstack/react-table';

export function useResetRowSelectionOnChange(setSelectedRows: Dispatch<SetStateAction<RowSelectionState>>, deps: unknown[]) {
  const depsKey = JSON.stringify(deps);

  useEffect(() => {
    setSelectedRows((prev) => (Object.keys(prev).length === 0 ? prev : {}));
  }, [depsKey, setSelectedRows]);
}
